module.exports = __webpack_public_path__ + "img/document-gray.4d293688.svg";